import React, { useState } from 'react';
import utils from 'utils';
import { CONSTANTS } from 'utils/constant';
import "./Appointment.scss";
import CommonButton from 'Components/CommonButton';
import Icons from "Common/Icons";
import { GreenEditIcon } from 'Common/ReactIcons';
import { Avatar } from 'antd';
import { useEffect } from 'react';
import api from 'utils/api';
import Loader from 'Components/Loader';
import { withTranslation, Trans } from 'react-i18next';
import { TS_STYLD_COMPS } from "Common/constant";
import { t } from "i18next";
import PhotoSkeleton from "Components/PhotoSkeleton";

function SelectActivePlan(props) {
  const { care_plan_arr = [], activeCarePlan = null, eligiblePlan = [], tgtLangST } = props;
  const active_key = activeCarePlan ? activeCarePlan.plan_key : null;
  const [selectedPlan, setSelectedPlan] = useState(active_key);
  const AvailablePlanMap = new Map();
  eligiblePlan.forEach(subscription => {
    AvailablePlanMap.set(subscription.plan_key, subscription);
  });
  let filteredCarePlans = care_plan_arr.map(carePlan => {
    const subscription = AvailablePlanMap.get(carePlan.plan_key);
    return subscription ? { ...carePlan, ...subscription } : null;
  }).filter(item => item !== null);
  function handlePlanChange(index) {
    setSelectedPlan(index);
  }

  function onSubmit() {
    const matchingPlan = filteredCarePlans.find(plan => plan.plan_key === selectedPlan);
    props.onClick(matchingPlan);
  }
  return (
    <div className='select-plan-modal'>
      <div className='header-div'>
        {CONSTANTS.CARE_PLAN_B2B}
      </div>
      <div className='select-plan-form'>
        <div className='form-label'><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CHOOSE_A_CARE_PLAN_TO_PROCEED_WITH_YOUR_APPOINTMENT_BOOKING, { lng: tgtLangST })}</Trans></div>
        <div className="plan-list-div">
          {filteredCarePlans.map((plan, index) => (
            plan.is_plan_active ? (
              <PlanCard
                key={plan.plan_key}
                plan={plan}
                index={index}
                isSelected={selectedPlan === plan.plan_key}
                onChange={handlePlanChange}
              />
            ) : null
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CommonButton
            className="common-button-green"
            onClick={onSubmit}
            label={CONSTANTS.CONTINUE}
            disabled={selectedPlan === null}
            style={{ height: "40px" }}
          />
        </div>
      </div>
    </div>
  )
}

function PlanCard(props) {
  const { plan, index, isSelected, onChange } = props;
  const handleClick = () => {
    onChange(plan.plan_key);
  }

  return (
    <div
      className={`holistic-care-progress ${isSelected ? 'selected-plan' : ''}`}
      onClick={handleClick}
    >
      <div className="content">
        <div>
          {isSelected ? <img src={Icons.circle_checked} /> : <img src={Icons.circle_unchecked} />}
        </div>
        <div className="plan-name">{plan.plan_name}</div>
        <div className='plan-end-date'>{CONSTANTS.VALID_UPTO_WITHOUT_COLON} <span>{utils.FormatDate(plan.plan_end_date, "DATE_14")}</span></div>
        <div className='plan-info'>{utils.sessionsCompletedText(plan?.completed_sessions, plan?.total_sessions)}</div>
      </div>

    </div>
  )
}
export function InfoCardEdit(props) {
  const { Icon,hide_edit=false } = props;
  return (
    <div className="holistic-care-progress1">
      <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
        <div>
          <PhotoSkeleton src={Icon}>
          <Avatar
            size={48}
            icon={<img className="welcome-doc-img" src={Icon ? Icon : Icons.dummy_doc_img} />} />
          </PhotoSkeleton></div>

        {/* Content */}
        <div className="content">
          <div className='content-title'>{props.title}</div>
          <div className='content-desc'>{props.description}</div>
        </div>
      </div>
      {!hide_edit&&<div onClick={props.onClick} style={{ cursor: "pointer" }}>
        <GreenEditIcon />
      </div>}
    </div>
  );
}
function SelectActivePlanWrapper(props) {
  const { doctorID = '',tgtLangST } = props;
  const [loading, setLoading] = useState(true);
  const [eligiblePlan, setEligiblePlan] = useState([]);
  function byPassPlan(subscription) {
    const { care_plan_arr, } = props;
    const carePlan = care_plan_arr.find(plan => plan.plan_key === subscription.plan_key);
    let matchingPlan = { ...carePlan, ...subscription,hide_edit:true };
    props.onClick(matchingPlan);
  }
  function clinicianPlanListApi() {
    api.clinician_plan_list({ clinician_id: doctorID }).then((res) => {
      let eligible_plan = res.data.data.results;
      if (eligible_plan.length == 1) { byPassPlan(eligible_plan[0]) } else { setEligiblePlan(eligible_plan); setLoading(false) }
    }).catch((err) => { console.log(err) }).finally(() => { })
  }
  useEffect(clinicianPlanListApi, [])
  return <>{
    loading ? <Loader tgtLangST={tgtLangST}/> :
      <SelectActivePlan {...props} eligiblePlan={eligiblePlan} />
  }
  </>
}
export default SelectActivePlanWrapper;